export default "__VITE_ASSET__BeoMrnIZ__"